module.exports = __webpack_public_path__ + "static/media/starwars.9b8b0377.png";